import { render, staticRenderFns } from "./OrderProduct.vue?vue&type=template&id=a5d9b83e"
import script from "./OrderProduct.vue?vue&type=script&lang=ts"
export * from "./OrderProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports